export enum AddressType {
    WARD = 'WARD',
    CITY = 'CITY',
    PROVINCE = 'PROVINCE',
}

export const ADDRESS_TYPE_CONFIG = {
    [AddressType.PROVINCE]: {
        label: 'Tỉnh/TP',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    },
    [AddressType.CITY]: {
        label: 'Quận/Huyện',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [AddressType.WARD]: {
        label: 'Phường/Xã',
        cssClass: 'text-sm !bg-purple-100 !text-purple-700'
    }
};

// For p-select options
export const ADDRESS_TYPE_OPTIONS = Object.entries(ADDRESS_TYPE_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

